(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/player-wager-list-subscription-slice.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/player-wager-list-subscription-slice.js');
"use strict";


const _RTK = RTK,
  createSlice = _RTK.createSlice,
  createEntityAdapter = _RTK.createEntityAdapter,
  combineReducers = _RTK.combineReducers,
  createReducer = _RTK.createReducer,
  createAction = _RTK.createAction;
const tipsenApi = svs.components.tipsen.store.tipsenApi;
const WagerStatus = svs.components.sport.tipsenShared.WagerStatus;
const wagerListSubscriptionAdapter = createEntityAdapter({
  selectId: _ref => {
    let wagerId = _ref.wagerId;
    return String(wagerId);
  }
});
const toggleSubscriptionOption = createAction('tipsen/toggleSubscriptionOption');
const makePlayerWagerListSubscriptionReducer = preloadedState => createReducer(preloadedState, builder => {
  builder.addCase(toggleSubscriptionOption, (state, action) => {
    const _action$payload = action.payload,
      productName = _action$payload.productName,
      status = _action$payload.status;
    if (Object.keys(state.correctsToggle).includes(productName)) {
      state.correctsToggle[productName][status] = !state.correctsToggle[productName][status];
    }
  });
});
const playerWagerListSubscriptionSlice = createSlice({
  name: 'WagerListSubscription',
  initialState: wagerListSubscriptionAdapter.getInitialState(),
  reducers: {
    addForecastSubscriptions: wagerListSubscriptionAdapter.addMany,
    toggleSubscriptionForWager: (state, _ref2) => {
      let wagerId = _ref2.payload.wagerId;
      state.entities[wagerId].isSubscribed = !state.entities[wagerId].isSubscribed;
    },
    deleteForecastSubscriptions: (state, _ref3) => {
      let wagerIds = _ref3.payload;
      wagerListSubscriptionAdapter.removeMany(state, wagerIds);
    }
  },
  extraReducers: builder => {
    builder.addMatcher(tipsenApi.endpoints.getPlayerWagers.matchFulfilled, (state, _ref4) => {
      let payload = _ref4.payload,
        meta = _ref4.meta;
      const _meta$arg$originalArg = meta.arg.originalArgs,
        status = _meta$arg$originalArg.status,
        pagingSortKey = _meta$arg$originalArg.pagingSortKey;
      const isProductToggled = meta.enhanchedData.isProductToggled;
      if (status === 'active') {
        const wagersData = [];
        const wagerIds = [];
        const noLongerActiveIds = [];
        let subscribedValue = false;
        if (!state.length && isProductToggled) {
          subscribedValue = true;
        }
        payload.wagers.forEach(wager => {
          wagerIds.push(wager.wagerId);
          wagersData.push({
            wagerId: wager.wagerId,
            drawNumber: wager.currentDrawNumber,
            productId: wager.productId,
            isSubscribed: subscribedValue
          });
        });
        const hasWagers = Boolean(payload.wagers.length);
        if (!pagingSortKey && state.ids.length || !hasWagers && state.ids.length) {
          state.ids.forEach(wagerId => {
            if (hasWagers && !wagerIds.includes(wagerId) || !hasWagers) {
              noLongerActiveIds.push(wagerId);
            }
          });
        }
        if (noLongerActiveIds.length) {
          wagerListSubscriptionAdapter.removeMany(state, noLongerActiveIds);
        }
        if (wagersData.length) {
          wagerListSubscriptionAdapter.addMany(state, wagersData);
        }
      }
    }).addMatcher(RTK.isAnyOf(toggleSubscriptionOption), (state, _ref5) => {
      let payload = _ref5.payload;
      const isToggleOn = payload.isToggleOn,
        status = payload.status;
      if (status === 'active') {
        Object.values(state.entities).forEach(wager => {
          wager.isSubscribed = isToggleOn;
        });
      }
    }).addMatcher(tipsenApi.endpoints.invalidatePlayerWagerTag.matchFulfilled, (state, _ref6) => {
      let meta = _ref6.meta;
      const wagerId = meta.arg.originalArgs.wagerId;
      wagerListSubscriptionAdapter.removeOne(state, wagerId);
    });
  }
});
const selectToggle = state => state.PlayerWager.WagerListSettings.WagerListSubscriptionSettings.correctsToggle;
const makePlayerWagerListReducer = preloadedState => combineReducers({
  WagerListForecastSubscriptions: playerWagerListSubscriptionSlice.reducer,
  WagerListSubscriptionSettings: makePlayerWagerListSubscriptionReducer(preloadedState)
});
setGlobal('svs.components.tipsen.store.reducers.playerWagerListSubscriptionSlice', {
  makePlayerWagerListReducer,
  actions: {
    wagerListForecastSubscriptions: playerWagerListSubscriptionSlice.actions,
    toggleSubscriptionOption
  },
  selectors: {
    wagerListForecastSubscriptions: wagerListSubscriptionAdapter.getSelectors(state => state.PlayerWager.WagerListSettings.WagerListForecastSubscriptions),
    wagerListSubscriptionSettings: {
      selectToggle
    }
  }
});

 })(window);